import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col, Button, Dropdown } from "react-bootstrap";
import RangeCredit from "../../Components/Game/Addons";
import { gameCoin } from "../../../actions/gameCoin";
import { setWallet } from "../../../actions/gameWallet";
import storage from "../../../Storage";
import C from "../../../Constant";
import {
  Event,
  __,
  forceSatoshiFormat,
  isValidNumber,
  wait,
  sendNotfication,
} from "../../../Helper";
import { IoAlertCircleOutline } from "react-icons/io5";

class Bet extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: this.props.engine,
      isLogged: storage.getKey("logged") !== null ? true : false,
      amount: forceSatoshiFormat(
        storage.getKey("lam") ? storage.getKey("lam") : 50.00
      ),
      started: false,
      fields: "Medium",
      profit: 0,
      cashout: false,
      inputDisabled: false,
      buttonText: "BET",
      btnType: "btn-bet",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleBet = this.handleBet.bind(this);
  }

  componentDidMount() {
    let { engine } = this.state;
    this._isMounted = true;
    this.props.gameCoin();
    engine.on(C.PLAY_TOWER, () => this.play());
    engine.on(C.CLICKED_TOWER, (data) => this.clicked(data));
    engine.on(C.CASHOUT_TOWER, () => this.end());
    engine.on(C.BUSTED_TOWER, () => this.busted());
    engine.on(C.ERORR_TOWER, (data) => this.error(data));
    engine.on("stop_playing", () => this.stopManual());
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  stopManual() {
    this.setState({ started: false, buttonText: "BET", inputDisabled: false });
  }

  busted = () => {
    if (this._isMounted) {
      this.setState({
        inputDisabled: true,
        inputDisabled2: true,
      });

      return this.end();
    }
  };

  end() {
    if (this._isMounted) {
      wait(2200).then(() => {
        this.setState({
          profit: 0,
          cashout: false,
          buttonText: "BET",
          btnType: "btn-bet",
          inputDisabled: false,
          inputDisabled2: false,
          started: false,
        });
      });
    }
  }

  play() {
    if (this._isMounted) {
      this.setState({
        started: true,
        inputDisabled: true,
        inputDisabled2: true,
        buttonText: "Game is Started!",
      });
    }
  }

  clicked(data) {
    if (this._isMounted) {
      let { profit, coin } = data;
      let calc = __.toNumber(profit) + __.toNumber(this.state.profit);
      let win = forceSatoshiFormat(calc);

      this.setState({
        inputDisabled: true,
        inputDisabled2: true,
        btnType: "btn-bet-success",
        buttonText: win + " " + coin + " CashOut",
        cashout: true,
        profit: win,
      });

      wait(2000).then(() => {
        this.setState({
          inputDisabled: false,
          inputDisabled2: false,
        });
      });
    }
  }

  error(data) {
    if (this._isMounted) {
      sendNotfication(data.message, "info", "top-center");

      if (data.code === "credit") this.props.setWallet(true, data.uid);

      this.setState({ inputDisabled: false });
    }
  }

  handleBet(e) {
    e.preventDefault();
    let { isLogged, amount } = this.state;

    // Check User
    if (!isLogged) {
      return Event.emit("showAuthModal", true);
    }

    if (parseFloat(amount) <= 0) {
      this.setState({ amount: forceSatoshiFormat(50.00) });
    } else {
      amount = Math.min(
        parseFloat(storage.getKey("credit")),
        parseFloat(amount)
      );
      this.setState({ amount: forceSatoshiFormat(amount) });
    }

    this.setState({ inputDisabled: true });
    this.placeBet();
  }

  placeBet() {
    if (this._isMounted) {
      let { amount, engine, cashout, profit } = this.state;
      engine.init = true;

      if (cashout) {
        engine.profit = profit;
        engine.cashout();
        return;
      }

      wait(100).then(() => {
        engine.amount = amount;
        engine.coin = this.props.coin;
        engine.start();
      });
    }
  }

  handleInputChange(event) {
    let target = event.target;
    let value = target.value;

    if (target.name === "amount") {
      this.setState({ amount: value });
      if (!isValidNumber(value)) return;
    }

    if (target.name === "amount") {
      storage.setKey("lam", value);
    }

    this.setState({ [target.name]: value });
  }

  handleInputFields = (value) => {
    if (!this.state.started) {
      this.setState({ fields: value });
      Event.emit("tower_risk", value);
    }
  };

  setAmount = (val) => {
    var am = forceSatoshiFormat(val);
    this.setState({ amount: am });
    storage.setKey("lam", am);
  };

  render() {
    let { inputDisabled, inputDisabled2, fields } = this.state;
    return (
      <>
        <form
          className="w-100"
          onSubmit={(e) => {
            e.preventDefault();
            if (this.props.coin === "inr") {
              if (this.state.amount < 20) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else if (this.props.coin === "inr") {
              if (this.state.amount < 0.5) {
                sendNotfication("Enter valid amount");
              } else {
                this.handleBet(e);
              }
            } else {
              this.handleBet(e);
            }
          }}
        >
          <Row>
            <Col className="col-md-12">
              <div className="crash-bet-input-label font-family-for-all">
                <div className="crash-bet-input-label-left ">
                  <div>Amount</div>
                  <div style={{ paddingLeft: "5px" }}>
                    <IoAlertCircleOutline color="#56CF17" size={"17px"} />
                  </div>
                </div>
                
              </div>
              <div className={"form-group mb-1 bet-input"}>
                <div className="input-group">
                  <div className="input-group-append">
                    <span className="input-group-text crash-game-bet-game">
                      <img
                        src={"/assets/images/USDT.png"}
                        className={"mini-coin-7"}
                        alt=""
                      />
                      {/* BET */}
                    </span>
                  </div>
                  <input
                    style={{ background: "#222328", paddingLeft: "0px" }}
                    disabled={inputDisabled2}
                    type="text"
                    className="form-control text-left"
                    id="amount"
                    name="amount"
                    placeholder="Enter Bet Amount"
                    value={this.state.amount}
                    autoComplete={"off"}
                    onKeyUp={this.handleInputChange}
                    onChange={this.handleInputChange}
                  />
                  <div className="input-group-append">
                    <RangeCredit set={this.setAmount} />
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-md-12 font-family-for-all">
              <div className="crash-bet-input-label">
                <div className="crash-bet-input-label-left">
                  <div>RISK</div>
                </div>
              </div>
              <div className={"form-group mb-1"}>
                <div className="input-group fw">
                  <div className="input-group-append">
                    <span className="input-group-text crash-game-bet-game">
                      <i className="mdi mdi-bomb font-25 text-danger mr-1" />
                      {/* RISK */}
                    </span>
                  </div>
                  <Dropdown
                    style={{
                      background: "#222328",
                      paddingLeft: "0px",
                      borderTopRightRadius: "20px",
                      borderBottomRightRadius: "20px",
                    }}
                    drop={""}
                    className={"drop-select btn-block "}
                  >
                    <Dropdown.Toggle split variant="" className={"py-0 mt-0"}>
                      <span className="text-muted text-center font-family-for-all">
                        <i className={"mdi mdi-chevron-down mr-1"} /> {fields}
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      disabled={inputDisabled2}
                      className={"dopdown-menu-bottom" + inputDisabled2}
                    >
                      <Dropdown.Item
                        onClick={(e) => this.handleInputFields("Medium")}
                        className={"animated fadeIn font-family-for-all"}
                      >
                        Medium
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={(e) => this.handleInputFields("High")}
                        className={"animated fadeIn font-family-for-all"}
                      >
                        High
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </Col>
          </Row>
          {/* <div>
              <span style={{fontSize:11,marginLeft:5}}>
                {this.props.coin ==='USDT' ?
              "(Minimum Bet - 20 USDT)"
              :
              "(Minimum Bet - 0.5 USDT)"
              }
              </span>
              </div> */}
          <Row style={{ marginTop: "10px", marginBottom: "10px" }}>
            <Col className=" m-auto col-md-12">
              <div className={"form-group rev mt-2 mb-0"}>
                <Button
                  className="start-auto-bet-mode-button"
                  style={{
                    // border: "2px solid red",
                    color: "#fff",
                    boxShadow:
                      "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px #9fe871 inset",

                    // backgroundColor: "rgb(67, 179, 9)",
                    backgroundImage:
                      "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                    borderRadius: "10px",
                  }}
                  variant={"btn btn-md btn-block mt-2 " + this.state.btnType}
                  disabled={inputDisabled}
                  type="submit"
                >
                  {this.state.buttonText}
                </Button>
              </div>
            </Col>
          </Row>
        </form>
      </>
    );
  }
}

Bet.propTypes = {
  coin: PropTypes.string,
  credit: PropTypes.string,
};

const mapStateToProps = (state) => ({
  coin: state.items.coin,
  credit: state.items.credit,
});

export default connect(mapStateToProps, {
  gameCoin,
  setWallet,
})(Bet);
